(function(){
  var root = document.getElementById('dcm');
  if(!root) return;
  var DATA = [];
  try { DATA = JSON.parse(document.getElementById('dcmData').textContent) || []; } catch(e){ DATA = []; }

  var grid  = document.getElementById('dcmGrid');
  var empty = document.getElementById('dcmEmpty');
  var countEl = document.getElementById('dcmCount');
  var sortEl  = document.getElementById('dcmSort');
  var cpInput = document.getElementById('dcmCP');

  var ICONS = {
    salon: "<rect x='3' y='6' width='18' height='14' rx='2'></rect><circle cx='12' cy='13' r='3.2'></circle><path d='M8 6l1.4-2.2h5.2L16 6'></path>",
    barberia: "<path d='M6 4l12 12'></path><path d='M18 4L6 16'></path><circle cx='6' cy='19' r='2.4'></circle><circle cx='18' cy='19' r='2.4'></circle>",
    tienda: "<path d='M3 9l1.5-5h15L21 9'></path><path d='M4 9v11h16V9'></path><path d='M9 20v-6h6v6'></path>"
  };
  function norm(s){ return (s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim(); }
  function iconFor(tipo){
    var k = norm(tipo).toLowerCase();
    if(k.indexOf('barber') === 0) return ICONS.barberia;
    if(k.indexOf('tienda') === 0) return ICONS.tienda;
    return ICONS.salon;
  }
  function esc(s){ return (s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  function openState(horario){
    if(!horario) return null;
    var days = ['dom','lun','mar','mie','jue','vie','sab'];
    var now = new Date();
    var today = days[now.getDay()];
    var lines = horario.split(/\r?\n/);
    var line = null;
    for(var i=0;i<lines.length;i++){
      var L = norm(lines[i]).toLowerCase();
      if(L.indexOf(today) > -1){ line = lines[i]; break; }
    }
    if(!line) return null;
    if(norm(line).toLowerCase().indexOf('cerrado') > -1) return { open:false, txt:'Cerrado hoy' };
    var m = line.match(/(\d{1,2})[:.](\d{2})\s*[-a\u2013]\s*(\d{1,2})[:.](\d{2})/);
    if(!m) return null;
    var mins = now.getHours()*60 + now.getMinutes();
    var a = parseInt(m[1],10)*60 + parseInt(m[2],10);
    var b = parseInt(m[3],10)*60 + parseInt(m[4],10);
    var hh = (m[3].length<2?'0':'') + m[3];
    var oh = (m[1].length<2?'0':'') + m[1];
    if(mins >= a && mins < b) return { open:true, txt:'Abierto ahora \u00b7 cierra a las ' + hh + ':' + m[4] };
    return { open:false, txt:'Cerrado \u00b7 abre a las ' + oh + ':' + m[2] };
  }

  function km(a,b,c,d){
    if(!a || !c) return null;
    var R=6371, t=function(x){return x*Math.PI/180;};
    var dLat=t(c-a), dLon=t(d-b);
    var s=Math.sin(dLat/2)*Math.sin(dLat/2)+Math.cos(t(a))*Math.cos(t(c))*Math.sin(dLon/2)*Math.sin(dLon/2);
    return R*2*Math.atan2(Math.sqrt(s),Math.sqrt(1-s));
  }

  function card(p){
    var h = "<div class='dcm__card'>";
    h += "<div class='dcm__ph'>";
    if(p.foto){
      h += "<img src='" + esc(p.foto) + "' alt='" + esc(p.nombre) + "' loading='lazy'>";
    } else {
      h += "<div class='dcm__fb'><svg viewBox='0 0 24 24' width='44' height='44' fill='none' stroke='#4F6F52' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'>" + iconFor(p.tipo) + "</svg><span>" + esc(p.tipo) + "</span></div>";
    }
    h += "</div><div class='dcm__cb'>";
    h += "<div class='dcm__r1'><span class='dcm__nm'>" + esc(p.nombre) + "</span>";
    if(p._km != null) h += "<span class='dcm__ds'>a " + p._km.toFixed(1).replace('.',',') + " km</span>";
    h += "</div>";
    h += "<div class='dcm__bg'><span class='dcm__bt'>" + esc(p.tipo) + "</span><span class='dcm__bo'>&#10003; Punto oficial</span></div>";
    h += "<div class='dcm__ad'><b>" + esc(p.direccion) + "</b><br>" + (p.barrio ? esc(p.barrio) + " \u00b7 " : "") + esc(p.cp) + " " + esc(p.ciudad) + "</div>";
    var st = openState(p.horario);
    if(st){
      h += "<div class='dcm__op'><span class='dcm__dot' style='background:" + (st.open ? "#4F6F52" : "#DCC9B7") + "'></span> " + esc(st.txt) + "</div>";
    }
    var dest = encodeURIComponent(p.direccion + ', ' + p.cp + ' ' + p.ciudad);
    h += "<div class='dcm__ac'><a class='dcm__llegar' target='_blank' rel='noopener' href='https://www.google.com/maps/dir/?api=1&destination=" + dest + "'>C\u00f3mo llegar</a>";
    if(p.tel) h += "<a class='dcm__ib' href='tel:" + esc(p.tel.replace(/\s/g,'')) + "' aria-label='Telefono'><svg viewBox='0 0 24 24' width='15' height='15' fill='none' stroke='currentColor' stroke-width='1.7' stroke-linecap='round' stroke-linejoin='round'><path d='M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z'></path></svg></a>";
    if(p.ig){
      var ig = p.ig.replace('@','').replace(/^https?:\/\/(www\.)?instagram\.com\//,'').replace(/\/$/,'');
      h += "<a class='dcm__ib' target='_blank' rel='noopener' href='https://instagram.com/" + esc(ig) + "' aria-label='Instagram'><svg viewBox='0 0 24 24' width='15' height='15' fill='none' stroke='currentColor' stroke-width='1.7'><rect x='3' y='3' width='18' height='18' rx='5'></rect><circle cx='12' cy='12' r='4'></circle><circle cx='17.5' cy='6.5' r='1' fill='currentColor' stroke='none'></circle></svg></a>";
    }
    var w = p.wa || p.tel;
    if(w){
      h += "<a class='dcm__ib wa' target='_blank' rel='noopener' href='https://wa.me/" + esc(w.replace(/[^\d]/g,'')) + "' aria-label='WhatsApp'><svg viewBox='0 0 32 32' width='17' height='17' fill='#fff'><path d='M16 3C9.4 3 4 8.4 4 15c0 2.1.6 4.1 1.6 5.9L4 29l8.3-1.6c1.7.9 3.6 1.4 5.7 1.4 6.6 0 12-5.4 12-12S22.6 3 16 3zm0 21.8c-1.8 0-3.5-.5-5-1.4l-.4-.2-3.7.7.7-3.6-.2-.4c-1-1.6-1.5-3.4-1.5-5.3 0-5.4 4.4-9.8 9.8-9.8s9.8 4.4 9.8 9.8-4.4 9.8-9.8 9.8z'></path></svg></a>";
    }
    h += "</div><p class='dcm__conf'>Llama para confirmar disponibilidad</p>";
    h += "</div></div>";
    return h;
  }

  function render(list, label, sortLabel){
    grid.innerHTML = '';
    if(!list.length){
      empty.classList.remove('dcm__hide');
      countEl.textContent = '';
      sortEl.textContent = '';
      return;
    }
    empty.classList.add('dcm__hide');
    var n = list.length;
    countEl.innerHTML = n + (n === 1 ? ' punto de venta' : ' puntos de venta') + (label ? " cerca de <b>" + esc(label) + "</b>" : "");
    sortEl.textContent = sortLabel || '';
    var html = '';
    for(var i=0;i<list.length;i++) html += card(list[i]);
    grid.innerHTML = html;
  }

  function byCP(cp){
    cp = (cp||'').replace(/\D/g,'');
    if(cp.length < 2){ render(DATA.slice(0,8), '', DATA.length ? 'Puntos oficiales' : ''); return; }
    var exact = [], prov = [];
    var pre = cp.slice(0,2);
    for(var i=0;i<DATA.length;i++){
      var d = DATA[i]; d._km = null;
      var c = (d.cp||'').replace(/\D/g,'');
      if(cp.length === 5 && c === cp) exact.push(d);
      else if(c.slice(0,2) === pre) prov.push(d);
    }
    var list = exact.concat(prov);
    render(list, cp, list.length ? 'Ordenados por cercan\u00eda' : '');
  }

  function byCity(city){
    var k = norm(city).toLowerCase(), out = [];
    for(var i=0;i<DATA.length;i++){
      DATA[i]._km = null;
      if(norm(DATA[i].ciudad).toLowerCase().indexOf(k) > -1) out.push(DATA[i]);
    }
    render(out, city, out.length ? 'Ordenados por nombre' : '');
  }

  document.getElementById('dcmGo').addEventListener('click', function(){ byCP(cpInput.value); });
  cpInput.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); byCP(cpInput.value); } });
  var cityBtns = root.querySelectorAll('.dcm__city');
  for(var i=0;i<cityBtns.length;i++){
    cityBtns[i].addEventListener('click', function(){ cpInput.value=''; byCity(this.getAttribute('data-city')); });
  }
  document.getElementById('dcmGeo').addEventListener('click', function(){
    if(!navigator.geolocation) return;
    var btn = this; btn.textContent = 'Buscando\u2026';
    navigator.geolocation.getCurrentPosition(function(pos){
      btn.innerHTML = '&#9678; Usar mi ubicaci\u00f3n';
      var la = pos.coords.latitude, lo = pos.coords.longitude, out = [];
      for(var i=0;i<DATA.length;i++){
        var d = DATA[i];
        d._km = (d.lat && d.lng) ? km(la, lo, d.lat, d.lng) : null;
        out.push(d);
      }
      out.sort(function(a,b){
        if(a._km == null) return 1;
        if(b._km == null) return -1;
        return a._km - b._km;
      });
      cpInput.value = '';
      render(out, 'ti', 'Ordenados por distancia');
    }, function(){ btn.innerHTML = '&#9678; Usar mi ubicaci\u00f3n'; });
  });

  document.getElementById('dcmAviso').addEventListener('submit', function(e){
    e.preventDefault();
    var b = this.querySelector('button');
    b.disabled = true; b.textContent = '\u00a1Gracias!';
  });

  render(DATA.slice(0,8), '', DATA.length ? 'Puntos oficiales' : '');
  if(!DATA.length) empty.classList.remove('dcm__hide');
})();
